import * as BlogApiActions from '@app/modules/blogs/actions/blog-api.actions';
import { BlogTableItemModel } from '@app/modules/blogs/models/';
import { TableOverviewModel } from '@app/shared/models/table/table-overview.model';
import { TableStateModel } from '@app/shared/models/table/table-state.model';
import { applySortingOrDefault } from '@app/shared/utilities/overview-reducer.utilities';
import { createReducer, on } from '@ngrx/store';

const initialState: State = new TableOverviewModel<BlogTableItemModel>('publishDate');

export interface State extends TableStateModel<BlogTableItemModel> {}

export const reducer = createReducer(
  initialState,
  on(BlogApiActions.GetOverview, (state) => ({ ...state, loading: true })),
  on(BlogApiActions.GetOverviewSuccess, (state, response) => ({
    ...state,
    ...response,
    loading: false,
  })),
  on(BlogApiActions.GetOverviewError, (state) => ({
    ...state,
    loading: false,
  })),
  on(BlogApiActions.FilterOverview, (state, { sorting, pagination }) => ({
    ...state,
    sorting: applySortingOrDefault(initialState, sorting),
    pagination: {
      ...state.pagination,
      page: pagination.page,
      pageSize: pagination.pageSize,
    },
  })),
  on(BlogApiActions.ResetOverview, () => ({ ...initialState }))
);

export const getLoading = (state: State) => state.loading;
export const getList = (state: State) => state.list;
export const getPagination = (state: State) => state.pagination;
export const getSorting = (state: State) => state.sorting;
